export default "__VITE_ASSET__DOlcEIC0__"